<!-- <ngx-loading [show]="loading | async" ></ngx-loading> -->

@if (loading | async) {
    <div id="splash-screen" class="splash-screen splash-screen-loader">
        <div class="d-flex flex-column gap-3 align-items-center">
            <div class="containerSpinnerAndLogo d-flex flex-column gap-2 justify-content-center align-items-center" >
                <img [src]="logoShort" alt="Logo" />
                <section class="d-flex flex-column justify-content-center align-items-center gap-2">
                    <span class="container-spinner spinner-border border-3"  role="status">
                        <span class="visually-hidden">Carrendo...</span>
                    </span>
                </section>
            </div>
            @if (message$ | async; as msg) {
                <span class="loader-message fw-semibold fs-5 text-center">{{ msg }}</span>
            }
        </div>
    </div>

}